export const EXPORT_PARAM_KEY = 'exportFile';
export const EXPORT_ALL_PARAM_KEY = 'isExportAll';
export const EXPORT_ALL_VALUE = 'all';
export const RESPONSE_TYPE = 'blob';
export const INITIAL_LABEL_DOWNLOAD = 'a';
export const FILE_NAME_PREFIX = 'export';

export const EXPORT_REPORT_I18N = {
  SCOPE_FILTERED: 'ExportReportButton.Scope.Filtered',
  SCOPE_ALL: 'ExportReportButton.Scope.All',
  SCOPE_PAGE: 'ExportReportButton.Scope.Page',
  TOOLTIP_GENERATING: 'ExportReportButton.Tooltip.Generating',
  TOOLTIP_DOWNLOADED: 'ExportReportButton.Tooltip.Downloaded',
  TOOLTIP_ERROR: 'ExportReportButton.Tooltip.Error',
  TOOLTIP_EXPORT: 'ExportReportButton.Tooltip.Export',
} as const;

export const PROGRESS_ANIMATION = {
  INITIAL: 0,
  MAX_ANIMATED: 99,
  RATE_THRESHOLD: 70,
  RATE_FAST_MULTIPLIER: 0.08,
  RATE_FAST_BASE: 0.6,
  RATE_SLOW_MULTIPLIER: 0.012,
  RATE_SLOW_BASE: 0.05,
  INTERVAL_MS: 80,
  COMPLETED: 100,
} as const;

export const DOWNLOAD_DELAYS = {
  DONE_FINALIZE_MS: 120,
  DONE_RESET_MS: 1800,
  ERROR_RESET_MS: 2500,
} as const;
